import React, { useCallback, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { Box } from '@atlaskit/primitives';
import { Section } from '@atlaskit/side-navigation';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { messages } from '../messages.tsx';
import type { QueueGroupsProps } from './main.tsx';

export const QueueGroupsSectionLoader = lazyForPaint(
	() => import(/* webpackChunkName: "jsm-sidebar-queue-groups-section" */ './main'),
	{
		ssr: true,
	},
);

export const QueueGroupsSection = (props: QueueGroupsProps) => {
	const { formatMessage } = useIntl();

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const reload = useCallback(() => window.location.reload(), []);
	const Fallback = useCallback(
		() => (
			<Section title={formatMessage(messages.queuesGroupErrorHeading)}>
				<Box padding="space.100">
					{formatMessage(messages.queuesGroupErrorBody, {
						button: (buttonLabel: ReactNode) => (
							<Button spacing="none" appearance="link" onClick={reload}>
								{buttonLabel}
							</Button>
						),
					})}
				</Box>
			</Section>
		),
		[formatMessage, reload],
	);
	return (
		<ErrorBoundary render={Fallback}>
			<QueueGroupsSectionLoader {...props} />
		</ErrorBoundary>
	);
};
